import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDetailsIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 25,
	viewBox: "0 0 24 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		opacity: .5,
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M15 3.05273V8.05273H20",
				stroke: "#2B313A",
				strokeWidth: 1.5,
				strokeLinecap: "round",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("rect", {
				x: 4,
				y: 2.61328,
				width: 16,
				height: 19.4401,
				rx: 4,
				stroke: "#2B313A",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 16.5527H8",
				stroke: "#2B313A",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M16 12.5527H8",
				stroke: "#2B313A",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M11 8.55273H8",
				stroke: "#2B313A",
				strokeWidth: 1.5,
				strokeLinecap: "square",
				strokeLinejoin: "round"
			})
		]
	})
});
export default SvgDetailsIcon;
